import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine'
import { ClassementPopulated } from '../types'
import { useCompetitionProps } from '../../hooks/useCompetitionProps'
import React from 'react'
import style from './style.module.scss'
import { MiniClassementLine } from './MiniClassementLine'
import AdComponent from '../../advertisement/components/AdComponent'
import { Ad } from '../../types'

interface ClassementProps {
    classements: ClassementPopulated[] | null
    ads: Ad[]
    adLocationSlug: string | null
}

const MiniClassement = ({ classements }: { classements: ClassementPopulated[] }) => {
    return (
        <>
            <h4 className={style.header}>Classement</h4>
            <table className={style.classement}>
                <thead>
                    <tr>
                        <th title="Position">Pos.</th>
                        <th title="Club">Club</th>
                        <th title="Points">Pts</th>
                    </tr>
                </thead>
                <tbody>
                    {classements.map((classement) => (
                        <MiniClassementLine key={classement.id} classement={classement} />
                    ))}
                </tbody>
            </table>
        </>
    )
}

const MiniClassementOrAds = (attributes) => {
    const {
        attributes: { classements, ads, adLocationSlug },
    } = useCompetitionProps<ClassementProps>({ initDataFromPhpFirstRendering: attributes })
    return (
        <BlockWrapper.Without>
            {classements ? (
                <MiniClassement classements={classements} />
            ) : (
                <AdComponent ads={ads} desktopOnly={true} taxonomySlug={adLocationSlug} />
            )}
        </BlockWrapper.Without>
    )
}

export default defineBlock({
    Block: MiniClassementOrAds,
})
